// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /*
  url: 'https://test76.red5g.co:9101/',
  //url_login: 'https://2rcgbg2iy1.execute-api.us-east-1.amazonaws.com/dev',
  //url_permissions: 'https://cl5jkfvlol.execute-api.us-east-1.amazonaws.com/dev',*/
  //url: 'https://motor-ecs-dev.demo-red5g.com/',
  url: 'https://test1.red5g.co:9102/', // no se usa
  url_ejecucion_motor: 'https://sandboxmotor.quuo.co/',
  url_login: 'https://blt7xbwd24.execute-api.us-east-1.amazonaws.com/pdn',
  url_permissions: 'https://cl5jkfvlol.execute-api.us-east-1.amazonaws.com/dev', // no se usa

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
